import { useCurrentModule } from '../components';
import { useSwitchFlows } from './useSwitchFlows';
export const AI_RECOMMENDATION_SPEC = 'specs.premium.EclipseDesktopSocialProof';
export const useAiRecommendationEnabled = () => {
  const module = useCurrentModule();
  const {
    ready,
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    isSwitchFlow,
    isLoading: isSwitchFlowLoading
  } = useSwitchFlows();
  const isMobile = module.moduleName === 'eclipse-package-picker-mobile-module';
  const isLoading = !isMobile && (ready === false || isSwitchFlowLoading);
  const isEnabled = !isMobile && ready !== false && experiments.isEnabled(AI_RECOMMENDATION_SPEC) && !isSwitchFlowLoading && isSwitchFlow === false;
  return {
    isEnabled,
    isLoading
  };
};
//# sourceMappingURL=useAiRecommendationEnabled.js.map